import * as React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import BtnComponent from '../buttonComponent/BtnComponent';
import Typography from '@mui/material/Typography';

const PriceListConfirmationModal = ({
  onClose,
  open,
  description,
  heading,
  warning,
  proceedDownloadClick,
  ...props
}) => {
  const marginBottom = { mb: '28px' };

  return (
    <Dialog
      open={open}
      {...props}
      fullWidth
      maxWidth={'sm'}
      PaperProps={{ sx: { borderRadius: '16px' } }}>
      <>
        <IconButton
          onClick={onClose}
          sx={{ position: 'absolute', top: '16px', right: '16px' }}>
          <CloseIcon />
        </IconButton>
        <div style={{ padding: '24px' }}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
            }}>
            <Typography variant="h2" sx={marginBottom}>
              {heading}
            </Typography>
            <Typography variant="p" color="#666666" sx={marginBottom}>
              {description}
            </Typography>
            <Typography variant="h6" sx={marginBottom}>
              {warning}
            </Typography>
          </div>
          <div style={{ display: 'flex' }}>
            <BtnComponent
              title={'Proceed to download'}
              onClick={proceedDownloadClick}
            />
          </div>
        </div>
      </>
    </Dialog>
  );
};

PriceListConfirmationModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default PriceListConfirmationModal;
